const VOICE_ID_PATTERN = /^[0-9a-f]{32}$/i;

export function normalizeCharacterVoiceInput(value: string): string {
  const normalized = value.trim();
  if (!normalized) return "";
  if (VOICE_ID_PATTERN.test(normalized)) return normalized.toLowerCase();

  let url: URL;
  try { url = new URL(normalized); }
  catch { throw new Error("character_voice_invalid"); }
  const hostname = url.hostname.toLowerCase();
  const modelIds = url.searchParams.getAll("modelId");
  if (
    url.protocol !== "https:"
    || url.username !== ""
    || url.password !== ""
    || !(hostname === "fish.audio" || hostname.endsWith(".fish.audio"))
    || modelIds.length !== 1
    || !VOICE_ID_PATTERN.test(modelIds[0] ?? "")
  ) throw new Error("character_voice_invalid");
  return modelIds[0]!.toLowerCase();
}
